const pickNonEmptyText = (...values) => {
  for (const value of values) {
    if (value == null) continue;
    const text = String(value).trim();
    if (text) return text;
  }
  return null;
};

const readSearchTextLocal = () => {
  try {
    if (typeof localStorage === 'undefined') return null;
    return localStorage.getItem('searchTextLocal');
  } catch (_e) {
    return null;
  }
};

/**
 * Completa el payload de intenciones/soporte con la búsqueda activa en Redux.
 * searchInfo.id nace en startRegisterSearchInfo (searchinfos) y debe viajar
 * a user_interests.searchinfo_id / user_support_requests.searchinfo_id.
 * searchText no siempre llega en el prop (input limpio, ficha View, persist del id):
 * se toma del SearchInfo, historial, store de escritura o searchTextLocal.
 */
export const withSearchIntentContext = (payload = {}, state = {}) => {
  const searchInfo = state.searchInfo?.searchInfo || {};
  const originIds = Array.isArray(payload.originIds)
    ? payload.originIds.map((n) => Number(n)).filter((n) => n > 0)
    : [];
  const originId =
    payload.originId != null
      ? Number(payload.originId)
      : originIds[0] || null;

  return {
    ...payload,
    originIds: originIds.length ? originIds : payload.originIds,
    originId: originId || null,
    searchinfo_id:
      payload.searchinfo_id != null
        ? payload.searchinfo_id
        : searchInfo.id || null,
    searchText: pickNonEmptyText(
      payload.searchText,
      payload.search_text,
      searchInfo.text_search,
      searchInfo.textSearch,
      state.searchResult?.searchTextInStore,
      state.searchHistory?.searchText,
      state.configuration?.searchTextState,
      state.user?.searchTextState,
      readSearchTextLocal()
    ),
  };
};
